function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 12.3a1 1 0 100-2 1 1 0 000 2zM24.9 12.3a1 1 0 100-2 1 1 0 000 2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11.3c0-4-3.7-7.3-8.3-7.3-3.5 0-6.5 1.9-7.7 4.6-.7-.2-1.5-.2-2.3-.2C6.4 8.3 2 12.2 2 16.9c0 3.5 2.4 6.6 6.1 7.9l-1.2 2.9c-.1.2 0 .3 0 .5.1.1.2.2.4.2h.1c2.6 0 4.6-1.6 6-3.1.1 0 .3 0 .4-.1 3.6-.7 6.4-3.2 7.3-6.3.9.8 2 1.4 3.4 1.4h.1c.2 0 .3-.1.4-.2.1-.2.1-.3 0-.5 0 0-.3-.7-.7-1.5 3.3-.8 5.7-3.5 5.7-6.8zm-16.6 12c-1.4.3-2.9.2-4.2-.2-3.1-.9-5.2-3.4-5.2-6.2 0-3.6 3.5-6.6 7.7-6.6.6 0 1.2.1 1.7.2.7.1 1.3.3 2 .6 2.2 1 3.7 2.9 4 5.1v.6c0 .5-.1 1-.2 1.4-.6 2.6-2.8 4.6-5.8 5.1zm8.3-6.6h-.3c-.1-3.3-2.3-6.1-5.5-7.5 1-1.9 3.2-3.2 5.8-3.2 3.5 0 6.3 2.4 6.3 5.3 0 3-2.8 5.4-6.3 5.4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 18a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM11.7 15.9c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1zM15.1 18a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z",
    fill: props.color
  }));
}

export default SvgIconChat;